import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { usePageTitle } from './App';

const NotFoundPage = () => {
  usePageTitle('Datagain Transcription  - 404 Page Not Found'); // Set tab title

  const navigate = useNavigate();

  return (
    <div
      style={{
        height: 'calc(100vh - 150px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <p className="word-404">404- Page Not Found</p>
        <Button variant="primary" style={{ padding: 'auto' }} onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>
    </div>
  );
};

export default NotFoundPage;
